import company from '../data/company.json';
import styles from './ClientsMarquee.module.css';

export default function ClientsMarquee() {
  // Duplicate for infinite scroll effect
  const clients = [...company.clients, ...company.clients];

  return (
    <section className={`${styles.section} section`}>
      <div className="container">
        <p className="section-label" style={{ textAlign: 'center', marginBottom: 8 }}>Trusted By</p>
        <h2 className="section-title" style={{ textAlign: 'center', marginBottom: 48 }}>
          Our Valued Clients
        </h2>
      </div>

      <div className={styles.marqueeWrap}>
        <div className={styles.marquee}>
          {clients.map((client, i) => (
            <div key={i} className={styles.logoWrap}>
              <img
                src={client.logo}
                alt={client.name}
                className={styles.logo}
                onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.nextSibling.style.display = 'flex';
                }}
              />
              <div className={styles.fallback} style={{ display: 'none' }}>
                {client.name}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
